import { render, staticRenderFns } from "./printgen.vue?vue&type=template&id=72712d7c&"
import script from "./printgen.vue?vue&type=script&lang=js&"
export * from "./printgen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports